import AbstractAccordion from './AbstractAccordion'
import { shallowRef } from 'vue'
import BulletsComponent from '@/modules/common/common/components/insuranceAccordions/BulletsComponent.vue'

export default class AccordionBullets extends AbstractAccordion<string> {
  component = shallowRef(BulletsComponent)

  constructor(attributes: Partial<AccordionBullets>) {
    super(attributes)
  }
}
